/* eslint no-template-curly-in-string: 0 */
import safewayLogo from "../../assets/images/safeway-alberstons-logo.png";
import safewayCardLogo from '../../assets/images/safeway-card-logo.png';
import { FLOW_TYPES, PAYMENT_STATUSES, PAYMENT_NETWORKS } from "../../utils/enums";

const css = {
  // ":root": {
  //   "--btn-primary-bg-color": "red",
  //   "--btn-primary-bg-color-hover": "red",
  //   "--btn-primary-font-color": "#fff",
  //   "--btn-primary-font-color-hover": "#fff"
  // },
};

const aboutNetworkFaq = {
  answer: "<div><strong>Redemption Steps.</strong> Present card or printed eGift to cashier as tender. Customer must present physical card or printed eGift.\n" +
    "Associate Instructions: Total order, Press EFT FULL, Press CANCEL to activate scanner/scale, scan the eGift barcode from the printed eGift.</div><br/><div><strong>eGiftCard Support.</strong> Purchase of card constitutes acceptance of the following terms: Card can be used for merchandise purchases only at any of the stores listed on this card, non-merchandise purchases (e.g. gift cards, money orders/transfers, lottery) are not allowed. Card may be used multiple times until value is depleted and cannot be redeemed for cash except where required by law. Funds will not be replaced on Lost/Stolen cards and Safeway Gift Card LLC is not responsible for use of card without your knowledge. Card does not expire and has no fees. For card balance call <a style=\"white-space: nowrap;\" href=\"tel:+1-888-413-5003\">1-888-413-5003</a>. Card can be used at any Albertsons, Safeway, Randalls, Tom Thumb, Pavilions, Vons, Carrs, Shaw's, Star Markets, Jewel-Osco and Acme Markets. In California, Tom Thumb is not a Safeway company. Issued by Safeway Gift Cards, LLC.  Distributed by Blackhawk Network, Inc. ©Safeway Gift Cards LLC. All rights reserved.</div><br/><div><strong>PLEASE TREAT THIS CARD LIKE CASH AND SAFEGUARD IT ACCORDINGLY</strong></div>",
  question: "About Albertsons® eGiftCard"
};

export const safeway = {
  id: PAYMENT_NETWORKS.EGIFT_BLACKHAWK_SAFEWAY,
  displayName: "Safeway",
  paymentFlow: "email",
  paywall: {
    tile: {
      displayName: "Safeway eGiftCard™",
      tagline: "Use online or in-store",
      description: [
        {
          string: "Buy groceries at 20+ retailers including",
          type: "div",
        },
        {
          string: "Albertsons, Safeway, Vons and more",
          type: "div",
        },
      ],
      // btnLabel: "Next",
      logo: safewayLogo
    }
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.AUTO_LOGIN,
    loading: {
      title: "Preparing your Safeway eGiftCard™"
    }
  },
  acceptPayment: {
    css,
    flow: FLOW_TYPES.ACCEPT_PAYMENT.AUTO_ACCEPT,
    description: [
      "You have chosen to receive a ",
      {
        string: "${payment.amount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      " Safeway eGiftCard which will be emailed to ",
      {
        string: "${payment.recipientEmail}.",
        props: {
          className: 'payment-recipientEmail',
        }
      }
    ],
    imgSrc: safewayCardLogo
  },
  paymentComplete: {
    initial: {
      description: [
        "Success! Please check your email ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail',
          },
        },
        " for details regarding your ",
        {
          string: "Safeway eGiftCard™",
          props: {
            className: 'payment-paymentNetwork',
          }
        },
        " for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ".",
      ],
      secondaryText: "Please treat this card like cash and care for it accordingly to avoid loss or theft.",
    },
    revisit: {
      description: [
        "An email was sent to ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          },
        },
        " on ",
        {
          string: "${payment.updatedAt}",
          props: {
            className: 'payment-updatedAt'
          },
          transformations: [
            {
              type: "formatDate"
            }
          ],
        },
        " with details regarding your ",
        {
          string: "Safeway eGiftCard™",
          props: {
            className: 'payment-paymentNetwork'
          }
        },
        " for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ".",
      ],
      secondaryText: "Please treat this card like cash and care for it accordingly to avoid loss or theft.",
    },
    imgSrc: safewayLogo,
  },
  faqs: {
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        aboutNetworkFaq
      ],
      [PAYMENT_STATUSES.ACCEPTED]: [
        aboutNetworkFaq
      ],
      [PAYMENT_STATUSES.COMPLETE]: [
        aboutNetworkFaq
      ]
    }
  },
  onHold: {
    imgSrc: safewayLogo,
    description: 'Your payment selection has been received. In most cases, funds are instantly sent; however in some instances it can take 24 to 48 hours for money to arrive.',
  }
};

export default safeway;
